<div
  class="variation-card-container"
  [class.clickable]="isClickableCard()"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
  [attr.role]="isClickableCard() ? 'button' : null"
  [attr.tabindex]="isClickableCard() ? 0 : null"
>
  @if (isLoadingPlaceholder()) {
    <div id="card-var-loading" class="loading-card">
      <app-ellipsis-loading />
      <span i18n="@@loadingInformation">Cargando información</span>
    </div>
  } @else if (isRegistrationData()) {
    <div id="card-var-header" class="variation-card-header">
      <div class="icon-wrapper">
        <app-icon [name]="iconName()"></app-icon>
      </div>
      <span class="variation-card-title">{{ viewModel().indicatorGroup | uppercase }}</span>
    </div>

    <div id="card-var-body" class="registration-card-body">
      <div>
        <span class="section-label" i18n="@@partnerRegistrationUpdatedFields"> Los siguientes campos han sido actualizados:</span>
      </div>
      <app-truncated-text
        class="changed-value"
        [text]="viewModel().fieldLabel || ''"
        [maxLines]="2"
      />
    </div>
  } @else if (isPartnerRegistrationData()) {
    <div id="card-var-header" class="variation-card-header">
      <div class="icon-wrapper">
        <app-icon [name]="iconName()"></app-icon>
      </div>
      <span class="variation-card-title">{{ viewModel().indicatorGroup | uppercase }}</span>
    </div>

    <div id="card-var-body" class="registration-card-body">
      <span class="section-label" i18n="@@partnerRegistrationUpdatedFields">
        Los siguientes campos han sido actualizados:
      </span>
      <app-truncated-text
        class="changed-value"
        [text]="viewModel().changedFields || ''"
        [maxLines]="2"
      />
    </div>
  } @else if (isPartnerShareholdingData()) {
    <div id="card-var-header" class="variation-card-header">
      <div class="icon-wrapper">
        <app-icon [name]="iconName()"></app-icon>
      </div>
      <span class="variation-card-title">{{ viewModel().indicatorGroup | uppercase }}</span>
    </div>

    <div id="card-var-body" class="registration-card-body">
      <span class="section-label" i18n="@@shareholdingChangesLabel">
        Hubo un cambio en el porcentaje de participación de:
      </span>
      <span class="variation-text">{{ viewModel().partnersLabel }}</span>
    </div>
  } @else {
    <div id="card-var-header" class="variation-card-header">
      <div class="icon-wrapper">
        <app-icon [name]="iconName()"></app-icon>
      </div>
      <span class="variation-card-title">{{ viewModel().indicatorGroup | uppercase }}</span>
    </div>

    <div id="card-var-body" class="variation-card-body">
      @if (isScore()) {
        @if (isPreviousScoreLetter()) {
          <div class="score-layout">
            <span class="section-label">Score registrado:</span>
            <div class="values-row">
              <span class="val-curr">{{ viewModel().currQ }}</span>
            </div>
          </div>
        } @else {
          <div class="score-layout">
            <span class="section-label">{{ viewModel().scoreLabel }}</span>
            <div class="values-row">
              <span class="val-prev">{{ viewModel().prevQ }}</span>
              <span class="arrow">→</span>
              <span class="val-curr">{{ viewModel().currQ }}</span>
            </div>
            <div class="variation-text" [class]="viewModel().alertType">
              {{ viewModel().formattedDiffQ }} {{ viewModel().pointsLabel }}
            </div>
          </div>
        }
      } @else {
        @if (hasQuantity()) {
          <div class="data-section">
            <span class="section-label" i18n="@@quantity">Cantidad:</span>
            <div class="values-row">
              <span class="val-prev">{{ viewModel().prevQ }}</span>
              <span class="arrow">→</span>
              <span class="val-curr">{{ viewModel().currQ }}</span>

              <span class="variation-text" [class]="viewModel().alertType">
                {{ viewModel().formattedDiffQ }}
              </span>
            </div>
          </div>
        }

        @if (hasValue()) {
          <div class="data-section">
            <span class="section-label" i18n="@@totalValueCurrency">Valor total ($):</span>
            <div class="values-row">
              <span class="val-prev">{{
                viewModel().prevV | currency: 'BRL' : '' : '1.2-2' : 'pt-BR'
              }}</span>
              <span class="arrow">→</span>
              <span class="val-curr">{{
                viewModel().currV | currency: 'BRL' : '' : '1.2-2' : 'pt-BR'
              }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
